import React, { useState } from 'react';
import UISectionWrapper, {
  UISectionHeader,
  UISectionBody,
} from '@/components/shared/UISectionWrapper';
import UISectionTitle from '@/components/shared/UISectionTitle';
import UIIconExtraButton from '@/components/shared/UIIconExtraButton';
import VacancyCalendarTable from '../VacancyCalendarTable';
import './VacancyCalendarSection.scss';

export interface VacancyCalendarData {
  id: string;
  date: string;
  vacancy: {
    status: 'PENDING' | 'DELAY' | 'VACANT' | 'WARNING';
  };
  tenant?: {
    name: string;
    email: string;
    avatar?: string;
  };
  unit: string;
  property: {
    name: string;
    type?: 'residential' | 'commercial' | 'mixed';
  };
}

interface VacancyCalendarSectionProps {
  data?: VacancyCalendarData[];
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onRowAction?: (id: string, action: string) => void;
}

// Мок-дані
const mockData: VacancyCalendarData[] = [
  {
    id: '1',
    date: '2025-10-24',
    vacancy: { status: 'PENDING' },
    tenant: { name: 'Frank Mitchell', email: 'frank@example.com' },
    unit: '203',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '2',
    date: '2025-10-01',
    vacancy: { status: 'PENDING' },
    tenant: { name: 'Woo Chang', email: 'chang@example.com' },
    unit: '204',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '3',
    date: '2024-10-01',
    vacancy: { status: 'DELAY' },
    tenant: { name: 'Amanda Stevenson', email: 'donec@example.com' },
    unit: '205',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '4',
    date: '2024-10-01',
    vacancy: { status: 'VACANT' },
    tenant: undefined, // Порожній рядок
    unit: '206',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '5',
    date: '2024-10-15',
    vacancy: { status: 'WARNING' },
    tenant: { name: 'Ron Chambers', email: 'ron@example.com' },
    unit: '207',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
];

const mockHandlers = {
  onToggleCollapse: () => console.log('Toggle vacancy calendar collapse'),
  onRowAction: (id: string, action: string) =>
    console.log('Vacancy row action:', id, action),
};

const VacancyCalendarSection: React.FC<VacancyCalendarSectionProps> = ({
                                                                         data = mockData,
                                                                         isCollapsed = false,
                                                                         onToggleCollapse = mockHandlers.onToggleCollapse,
                                                                         onRowAction = mockHandlers.onRowAction,
                                                                       }) => {
  const baseClass = 'VacancyCalendarSection';

  const headerAction = (
    <UIIconExtraButton
      icon={isCollapsed ? 'expand' : 'collapse'}
      onClick={onToggleCollapse}
      ariaLabel={isCollapsed ? 'Expand calendar' : 'Collapse calendar'}
    />
  );

  return (
    <UISectionWrapper
      className={baseClass}
      align="stretch"
    >
      <UISectionHeader>
        <UISectionTitle
          title="Vacancy calendar"
          action={headerAction}
          showDivider={true}
        />
      </UISectionHeader>

      {!isCollapsed && (
        <UISectionBody>
          <div className={`${baseClass}__content`}>
            <VacancyCalendarTable data={data} onRowAction={onRowAction} />
          </div>
        </UISectionBody>
      )}
    </UISectionWrapper>
  );
};

export default VacancyCalendarSection;